<form [formGroup]="applicantInfoForm">
  <div class="flex flex-col md:flex-row gap-4">
    <!-- First mat-card -->
    <mat-card class="md:w-1/2 w-full">
      <mat-card-content>
        <div class="flex flex-col gap-2">

          <div class="flex flex-col md:flex-row gap-2">
            <div class="flex flex-col gap-2 ">
            <button class="ml-auto" type="button" *ngIf="isLocked" mat-button color="primary" (click)="changeName()">Request Name Change</button>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-2">
            <div class="flex flex-col gap-2 md:w-1/3">
              <span class="font-semibold">Last Name</span>
              <mat-form-field>
                <mat-label>Last</mat-label>
                <input matInput formControlName="lastName">
                <mat-error *ngIf="applicantInfoForm.get('lastName')?.hasError('required')">
                  Last Name required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">First Name</span>
              <mat-form-field>
                <mat-label>First</mat-label>
                <input matInput formControlName="firstName">
                <mat-error *ngIf="applicantInfoForm.get('firstName')?.hasError('required')">
                  First Name required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Middle Name</span>
              <mat-form-field>
                <mat-label>Middle</mat-label>
                <input matInput formControlName="middleName">
                <mat-error *ngIf="applicantInfoForm.get('middleName')?.hasError('required')">
                  Middle Name required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-2">
            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Prior Name Used</span>
              <mat-form-field>
                <mat-label>Prior Name</mat-label>
                <input matInput formControlName="priorName">
              </mat-form-field>
            </div>
            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Gender</span>
              <mat-form-field>
                <mat-label>Gender</mat-label>
                <input matInput formControlName="gender">
                <mat-error *ngIf="applicantInfoForm.get('gender')?.hasError('required')">
                  Gender is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-2">
            <!-- SSN Block -->
            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Social Security Number</span>
              <mat-form-field class="form-field" appearance="fill">
                <mat-label>SSN</mat-label>
                <input matInput mask="000-00-0000" [type]="showSsn ? 'text' : 'password'" formControlName="ssn" placeholder="XXX-XX-XXXX" />
                <button mat-icon-button matSuffix [color]="showSsn ? 'primary' : 'warn'" [matTooltip]="showSsn ? 'Hide SSN' : 'Show SSN'"
                  matTooltipShowDelay="800" aria-label="Toggle SSN" (click)="toggleSsn()">
                  <mat-icon>{{ showSsn ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <mat-error *ngIf="applicantInfoForm.get('ssn')?.hasError('required')">
                  SSN is required
                </mat-error>
                <mat-error *ngIf="applicantInfoForm.get('ssn')?.hasError('incomplete')">
                  Please enter a complete SSN
                </mat-error>
                <mat-error *ngIf="applicantInfoForm.get('ssn')?.hasError('invalid')">
                  SSN must contain only numbers
                </mat-error>
              </mat-form-field>
            </div>

            <!-- DOB Block -->
            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Date Of Birth</span>
              <mat-form-field class="form-field">
                <mat-label>DOB</mat-label>
                <input matInput [matDatepicker]="picker"[min]="hundredYearsAgo" [max]="eighteenYearsAgo" formControlName="dateOfBirth">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="applicantInfoForm.get('dateOfBirth')?.hasError('required')">
                  Date Of Birth is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="flex flex-col md:flex-row gap-2">
            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Email</span>
              <mat-form-field>
                <mat-label>Email</mat-label>
                <input matInput formControlName="email">
                <mat-error *ngIf="applicantInfoForm.get('email')?.hasError('email')">
                  Enter a valid email address
                </mat-error>
              </mat-form-field>
            </div>
            <div class="flex flex-col gap-2 md:w-1/2">
              <span class="font-semibold">Telephone</span>
              <mat-form-field>
                <mat-label>Telephone</mat-label>
                <input matInput formControlName="phone" mask="000-000-0000" maxlength="12">
                <mat-error *ngIf="applicantInfoForm.get('phone')?.hasError('required')">
                  Phone number required
                </mat-error>
                <mat-error *ngIf="applicantInfoForm.get('phone')?.hasError('pattern')">
                  Format number as 000-000-0000
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="md:w-1/2 w-full md:ml-auto">
      <mat-card-header>
        <mat-card-title class="pb-4">
          <span class="font-semibold text-xl">Address</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <address *ngIf="applicantId > 0"
          [entityId]="applicantId"
          [entityType]="applicationEntityType"
          [limitEntries]="true"
          [canEdit]="true">
        </address>
      </mat-card-content>
    </mat-card>
  </div>
</form>
